import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { ApiResponse } from '../../../../../common/api/response.types'
import { CommissionRulesQuery } from './query.types'
import { IAuditEntry, ICommissionRule, ICommissionRulePreview } from './response.types'
import {
  CommissionRulePreviewQuery,
  CreateCommissionRulePayload,
  UpdateCommissionRulePayload,
} from './requests.types'

const BASE = `${API_URL}/api/internal/commission-rules`

type ListSuccess  = { success: true; data: ICommissionRule[]; totalRows?: number; nextCursor?: string | null }
type AuditSuccess = { success: true; data: IAuditEntry[]; totalRows?: number; nextCursor?: string | null }
type ApiFailure   = { success: false; errors: Record<string, string> & { general_error?: string } }

export type ListResponse  = ListSuccess  | ApiFailure
export type AuditResponse = AuditSuccess | ApiFailure

export const getCommissionRulesList = (params: CommissionRulesQuery) =>
  axios.get<ListResponse>(BASE, { params })

export const getCommissionRule = (id: string) =>
  axios.get<ApiResponse<ICommissionRule>>(`${BASE}/${encodeURIComponent(id)}`)

export const createCommissionRule = (body: CreateCommissionRulePayload) =>
  axios.post<ApiResponse<ICommissionRule>>(BASE, body)

export const updateCommissionRule = (id: string, body: UpdateCommissionRulePayload) =>
  axios.patch<ApiResponse<ICommissionRule>>(`${BASE}/${encodeURIComponent(id)}`, body)

export const deleteCommissionRule = (id: string) =>
  axios.delete<ApiResponse<null>>(`${BASE}/${encodeURIComponent(id)}`)

export const previewCommissionRule = (params: CommissionRulePreviewQuery) =>
  axios.get<ApiResponse<ICommissionRulePreview>>(`${BASE}/preview`, { params })

export const getCommissionRuleAudit = (
  id: string,
  params?: { cursor?: string; limit?: number },
) =>
  axios.get<AuditResponse>(`${BASE}/${encodeURIComponent(id)}/audit`, { params })

export const getCashboxKindLookup = () =>
  axios.get<ApiResponse<{ value: string; label: string }[]>>(`${BASE}/cashbox-kinds`)
